function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchPri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20C15.7467 20 20 15.7467 20 10.5C20 5.25329 15.7467 1 10.5 1C5.25329 1 1 5.25329 1 10.5C1 15.7467 5.25329 20 10.5 20Z",
    stroke: "#205A46",
    style: {
      stroke: "#205A46",
      stroke: "color(display-p3 0.1255 0.3529 0.2745)",
      strokeOpacity: 1
    },
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.501 17.4998L21.001 20.9998",
    stroke: "#205A46",
    style: {
      stroke: "#205A46",
      stroke: "color(display-p3 0.1255 0.3529 0.2745)",
      strokeOpacity: 1
    },
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPri);
export default __webpack_public_path__ + "static/media/searchPri.67544e8315ee124a1a99ea9c4ad417e1.svg";
export { ForwardRef as ReactComponent };